// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookCategory_sliderSection__SqpXp {
    max-width: 95%;
    margin: 0 auto;
    overflow: hidden;
  }
  
  .BookCategory_sliderHeader__2gtvA {
    max-width: 100%;
    margin: 0 auto;
    color: white;
    margin-bottom: 2rem;
  }
  
  .BookCategory_sliderTitle__BGpLb {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
  }
  
  .BookCategory_sliderSubtitle__Guuv1 {
    color: #fff;
    font-size: 1rem;
  }
  
  .BookCategory_sliderContainer__Znk6q {
    position: relative;
    display: flex;
    align-items: center;
    gap: 1rem;
    height: 280px;
  }
  
  .BookCategory_cardsContainer__Iopqd {
    width: calc(100% + 200px); /* Extend beyond screen */
    overflow: hidden;
    height: 100%;
    }
  
  .BookCategory_cardsWrapper__vAdAS {
    display: flex;
    transition: transform 0.5s ease;
    gap: 1.5rem;
    height: 100%;
  }
  
  .BookCategory_categoryCard__y6eaa {
    flex: 0 0 350px; /* Smaller fixed width */
    height: 280px; /* Smaller fixed height */
    position: relative;
    overflow: hidden;
  }
  
  .BookCategory_cardImageContainer__gIHwj {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  
  .BookCategory_cardImage__quT50 {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .BookCategory_cardOverlay__7U17Z {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0)); /* Flipped gradient direction */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .BookCategory_cardTitle__3YIH8 {
    color: white;
    font-size: 1.75rem;
    font-weight: bold;
    text-align: center;
  }
  
  .BookCategory_navButton__BCwFf {
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
  }
  
  .BookCategory_prevButton__DZMmU {
    left: 1rem;
  }
  
  .BookCategory_nextButton__z-6tr {
    right: 1rem;
  }
  
  .BookCategory_sliderDots__C7xbb {
    display: flex;
    justify-content: center;
    gap: 0.5rem;
    margin-top: 2rem;
  }
  
  .BookCategory_dot__UXXZ- {
    width: 24px;
    height: 4px;
    border-radius: 2px;
    background-color: #444;
    border: none;
    cursor: pointer;
  }
  
  .BookCategory_activeDot__6lZUR {
    background-color: white;
  }
  
  @media (max-width: 400px) {
    .BookCategory_sliderSection__SqpXp {
      padding: 2rem 0 2rem 0.5rem; /* Adjusted mobile padding */
    }
  }
  @media (max-width: 1200px) {
    .BookCategory_cardsContainer__Iopqd {
      width: calc(100% + 100px);
      margin-right: -100px;
    }
  }
  @media (max-width: 820px) {
    .BookCategory_sliderSection__SqpXp {
      .BookCategory_sliderSection__SqpXp {
        padding: 0.8rem 0rem 1rem 0rem; /* Adjusted mobile padding */
      } /* Adjusted mobile padding */
    }
    
    .BookCategory_sliderHeader__2gtvA,
  .BookCategory_sliderContainer__Znk6q {
    padding: 0 1.5rem; /* Adjusted mobile padding */
  }
    
    .BookCategory_categoryCard__y6eaa {
      width: 240px;
      height: 240px;
    }
    
    .BookCategory_cardsContainer__Iopqd {
      width: 100%;
      margin-right: 0;
    }
  }
  .BookCategory_clickable__Cww0Z {
    cursor: pointer;
    transition: transform 0.2s ease-in-out;
  }
  
  .BookCategory_clickable__Cww0Z:hover {
    transform: translateY(-5px);
  }
  
  .BookCategory_clickable__Cww0Z:focus {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }
  
  .BookCategory_categoryCard__y6eaa {
    -webkit-user-select: none;
            user-select: none;
  }
  @media (max-width: 488px) {
    .BookCategory_sliderSection__SqpXp {
      padding: 0.8rem 0rem 1rem 0rem; /* Adjusted mobile padding */
    }
    .BookCategory_sliderTitle__BGpLb {
      font-size: 1.5rem;
    }
  }
  
`, "",{"version":3,"sources":["webpack://./src/Blogs/Components/CSS/BookCategory.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,yBAAyB,EAAE,yBAAyB;IACpD,gBAAgB;IAChB,YAAY;IACZ;;EAEF;IACE,aAAa;IACb,+BAA+B;IAC/B,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe,EAAE,wBAAwB;IACzC,aAAa,EAAE,yBAAyB;IACxC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,sEAAsE,EAAE,+BAA+B;IACvG,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;EACb;;EAEA;IAEE,UAAU;EACZ;;EAEA;IAEE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,eAAe;EACjB;;EAEA;IAEE,uBAAuB;EACzB;;EAEA;IACE;MACE,2BAA2B,EAAE,4BAA4B;IAC3D;EACF;EACA;IACE;MACE,yBAAyB;MACzB,oBAAoB;IACtB;EACF;EACA;IACE;MACE;QACE,8BAA8B,EAAE,4BAA4B;MAC9D,EAAE,4BAA4B;IAChC;;IAEA;;IAEA,iBAAiB,EAAE,4BAA4B;EACjD;;IAEE;MACE,YAAY;MACZ,aAAa;IACf;;IAEA;MACE,WAAW;MACX,eAAe;IACjB;EACF;EACA;IACE,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,yBAAiB;YAAjB,iBAAiB;EACnB;EACA;IACE;MACE,8BAA8B,EAAE,4BAA4B;IAC9D;IACA;MACE,iBAAiB;IACnB;EACF","sourcesContent":[".sliderSection {\n    max-width: 95%;\n    margin: 0 auto;\n    overflow: hidden;\n  }\n  \n  .sliderHeader {\n    max-width: 100%;\n    margin: 0 auto;\n    color: white;\n    margin-bottom: 2rem;\n  }\n  \n  .sliderTitle {\n    font-size: 2rem;\n    font-weight: bold;\n    margin-bottom: 0.5rem;\n  }\n  \n  .sliderSubtitle {\n    color: #fff;\n    font-size: 1rem;\n  }\n  \n  .sliderContainer {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    height: 280px;\n  }\n  \n  .cardsContainer {\n    width: calc(100% + 200px); /* Extend beyond screen */\n    overflow: hidden;\n    height: 100%;\n    }\n  \n  .cardsWrapper {\n    display: flex;\n    transition: transform 0.5s ease;\n    gap: 1.5rem;\n    height: 100%;\n  }\n  \n  .categoryCard {\n    flex: 0 0 350px; /* Smaller fixed width */\n    height: 280px; /* Smaller fixed height */\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .cardImageContainer {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n  }\n  \n  .cardImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .cardOverlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0)); /* Flipped gradient direction */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .cardTitle {\n    color: white;\n    font-size: 1.75rem;\n    font-weight: bold;\n    text-align: center;\n  }\n  \n  .navButton {\n    position: absolute;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: white;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    z-index: 10;\n  }\n  \n  .prevButton {\n    composes: navButton;\n    left: 1rem;\n  }\n  \n  .nextButton {\n    composes: navButton;\n    right: 1rem;\n  }\n  \n  .sliderDots {\n    display: flex;\n    justify-content: center;\n    gap: 0.5rem;\n    margin-top: 2rem;\n  }\n  \n  .dot {\n    width: 24px;\n    height: 4px;\n    border-radius: 2px;\n    background-color: #444;\n    border: none;\n    cursor: pointer;\n  }\n  \n  .activeDot {\n    composes: dot;\n    background-color: white;\n  }\n  \n  @media (max-width: 400px) {\n    .sliderSection {\n      padding: 2rem 0 2rem 0.5rem; /* Adjusted mobile padding */\n    }\n  }\n  @media (max-width: 1200px) {\n    .cardsContainer {\n      width: calc(100% + 100px);\n      margin-right: -100px;\n    }\n  }\n  @media (max-width: 820px) {\n    .sliderSection {\n      .sliderSection {\n        padding: 0.8rem 0rem 1rem 0rem; /* Adjusted mobile padding */\n      } /* Adjusted mobile padding */\n    }\n    \n    .sliderHeader,\n  .sliderContainer {\n    padding: 0 1.5rem; /* Adjusted mobile padding */\n  }\n    \n    .categoryCard {\n      width: 240px;\n      height: 240px;\n    }\n    \n    .cardsContainer {\n      width: 100%;\n      margin-right: 0;\n    }\n  }\n  .clickable {\n    cursor: pointer;\n    transition: transform 0.2s ease-in-out;\n  }\n  \n  .clickable:hover {\n    transform: translateY(-5px);\n  }\n  \n  .clickable:focus {\n    outline: 2px solid #007bff;\n    outline-offset: 2px;\n  }\n  \n  .categoryCard {\n    user-select: none;\n  }\n  @media (max-width: 488px) {\n    .sliderSection {\n      padding: 0.8rem 0rem 1rem 0rem; /* Adjusted mobile padding */\n    }\n    .sliderTitle {\n      font-size: 1.5rem;\n    }\n  }\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sliderSection": `BookCategory_sliderSection__SqpXp`,
	"sliderHeader": `BookCategory_sliderHeader__2gtvA`,
	"sliderTitle": `BookCategory_sliderTitle__BGpLb`,
	"sliderSubtitle": `BookCategory_sliderSubtitle__Guuv1`,
	"sliderContainer": `BookCategory_sliderContainer__Znk6q`,
	"cardsContainer": `BookCategory_cardsContainer__Iopqd`,
	"cardsWrapper": `BookCategory_cardsWrapper__vAdAS`,
	"categoryCard": `BookCategory_categoryCard__y6eaa`,
	"cardImageContainer": `BookCategory_cardImageContainer__gIHwj`,
	"cardImage": `BookCategory_cardImage__quT50`,
	"cardOverlay": `BookCategory_cardOverlay__7U17Z`,
	"cardTitle": `BookCategory_cardTitle__3YIH8`,
	"navButton": `BookCategory_navButton__BCwFf`,
	"prevButton": `BookCategory_prevButton__DZMmU BookCategory_navButton__BCwFf`,
	"nextButton": `BookCategory_nextButton__z-6tr BookCategory_navButton__BCwFf`,
	"sliderDots": `BookCategory_sliderDots__C7xbb`,
	"dot": `BookCategory_dot__UXXZ-`,
	"activeDot": `BookCategory_activeDot__6lZUR BookCategory_dot__UXXZ-`,
	"clickable": `BookCategory_clickable__Cww0Z`
};
export default ___CSS_LOADER_EXPORT___;
